import { useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";

export default function AgentKYCSuccess({ baseUrl }) {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();

    useEffect(() => {
        const agentStripeId = searchParams.get("stripe_id");

        if (agentStripeId) {
            var formData = new FormData();
            formData.append("stripe_id", agentStripeId);

            axios.post(baseUrl + "/agentKYCSuccess", formData)
                .then(res => {
                    navigate("/agent/dashboard");

                })
                .catch(err => {
                    console.error("Stripe confirm error:", err);
                    Swal.fire({
                        icon: "error",
                        title: "Feil",
                        text: "Noe gikk galt med betalingen. Vennligst prøv igjen.",
                    });
                });
        }
    }, [searchParams]);

    return (
        <div className="p-6 text-center">
            <h1 className="text-xl font-bold">Please wait...</h1>
            <p>Returning you to your dashboard.</p>
        </div>
    );
}
